import { useQuery } from '@tanstack/react-query';
import useGetMarketingData from './useGetMarketingData';
import { getAutomations } from '../../services/automations';

interface Options {
  enabled?: boolean;
}

function useGetAutomations({ enabled = true }: Options = {}) {
  const { data: marketingData, isEnabled } = useGetMarketingData();

  const { data, isLoading, isFetching, isError, error, refetch } = useQuery({
    queryKey: ['marketing-automations', marketingData?.id],
    queryFn: () => getAutomations(marketingData?.id!),
    enabled: !!marketingData?.id && isEnabled && enabled,
  });

  return {
    data,
    // a disabled query is not "loading", but we still don't know the answer yet
    isPending: isLoading || !marketingData?.id,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  };
}

export default useGetAutomations;
